import { z } from "zod";
import { AgencyIdSchema } from "../primitives/ids.js";
/** Manual pilot outreach status labels (operator workflow). */
export const PilotOutreachStatusSchema = z.enum([
    "PROSPECT",
    "CONTACTED",
    "REPLIED",
    "DEMO_SCHEDULED",
    "PILOT_ACTIVE",
    "PAID_FIX_KIT",
    "DECLINED",
    "PAUSED",
]);
export const PilotOutreachIdSchema = z
    .string()
    .regex(/^potr_[a-zA-Z0-9_-]+$/)
    .brand();
export const PilotOutreachRecordV1Schema = z
    .object({
    schemaVersion: z.literal("pilot-outreach-record.v1.0"),
    outreachId: PilotOutreachIdSchema,
    agencyId: AgencyIdSchema,
    targetAgencyName: z.string().min(1).max(200),
    contactName: z.string().max(200).optional(),
    contactEmail: z.string().email().max(320).optional(),
    status: PilotOutreachStatusSchema,
    nextAction: z.string().max(500).optional(),
    manualNotes: z.string().max(4000).optional(),
    lastContactedAt: z.string().datetime().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
})
    .strict();
export const PilotOutreachCreateRequestV1Schema = z
    .object({
    schemaVersion: z.literal("pilot-outreach-create.v1.0"),
    targetAgencyName: z.string().min(1).max(200),
    contactName: z.string().max(200).optional(),
    contactEmail: z.string().email().max(320).optional(),
    status: PilotOutreachStatusSchema.optional(),
    nextAction: z.string().max(500).optional(),
    manualNotes: z.string().max(4000).optional(),
    lastContactedAt: z.string().datetime().optional(),
})
    .strict();
export const PilotOutreachUpdateRequestV1Schema = z
    .object({
    schemaVersion: z.literal("pilot-outreach-update.v1.0"),
    targetAgencyName: z.string().min(1).max(200).optional(),
    contactName: z.string().max(200).nullable().optional(),
    contactEmail: z.string().email().max(320).nullable().optional(),
    status: PilotOutreachStatusSchema.optional(),
    nextAction: z.string().max(500).nullable().optional(),
    manualNotes: z.string().max(4000).nullable().optional(),
    lastContactedAt: z.string().datetime().nullable().optional(),
})
    .strict();
export const PilotOutreachListV1Schema = z
    .object({
    schemaVersion: z.literal("pilot-outreach-list.v1.0"),
    items: z.array(PilotOutreachRecordV1Schema),
})
    .strict();
export const PilotOutreachExportRowV1Schema = z
    .object({
    outreachId: PilotOutreachIdSchema,
    targetAgencyName: z.string(),
    contactName: z.string().optional(),
    contactEmail: z.string().optional(),
    status: PilotOutreachStatusSchema,
    nextAction: z.string().optional(),
    manualNotes: z.string().optional(),
    lastContactedAt: z.string().optional(),
    updatedAt: z.string(),
})
    .strict();
//# sourceMappingURL=pilot-outreach.js.map